export default "__VITE_ASSET__42dc1270__"